/* ============================================================
   Landing page — corporate-fintech, light theme
   ============================================================ */

import React, { useState, useEffect } from 'react';
import { Wordmark, Icon } from '../components/shared.jsx';

// ===== WhatsApp floating button (with pulsing halo) =====
const WHATSAPP_URL = 'https://wa.me/5213327852376?text=Quiero%20proteger%20mis%20env%C3%ADos%20con%20AutoPackSafe.%20%C2%BFC%C3%B3mo%20puedo%20obtener%20m%C3%A1s%20informaci%C3%B3n%3F';

function WhatsAppFloat() {
  return (
    <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer"
       className="wa-float" aria-label="Contactar por WhatsApp" title="Contáctanos por WhatsApp">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413"/>
      </svg>
    </a>
  );
}

// ===== Social brand icons (filled — not part of the Lucide-stroke sprite) =====
function SocialIcon({ network }) {
  const paths = {
    facebook: <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073"/>,
    instagram: <><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069M12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0m0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324M12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8m6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881"/></>,
    linkedin: <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.063 2.063 0 1 1 2.063 2.065m1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003"/>,
  };
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      {paths[network]}
    </svg>
  );
}

const SOCIAL_LINKS = [
  { network: 'facebook',  label: 'Facebook',  url: 'https://www.facebook.com/Autopacksafemx' },
  { network: 'instagram', label: 'Instagram', url: 'https://www.instagram.com/autopacksafe/' },
  { network: 'linkedin',  label: 'LinkedIn',  url: 'https://www.linkedin.com/company/autopack-safe/' },
];

function SocialLinks() {
  return (
    <div className="flex items-center gap-2" style={{ marginTop: 20 }}>
      {SOCIAL_LINKS.map(s => (
        <a key={s.network} href={s.url} target="_blank" rel="noopener noreferrer"
           aria-label={s.label} title={s.label}
           style={{
             width: 36, height: 36, borderRadius: 8,
             display: 'flex', alignItems: 'center', justifyContent: 'center',
             background: 'var(--bg-muted)', color: 'var(--fg-secondary)',
             border: '1px solid var(--border-faint)',
             transition: 'all 0.15s ease',
           }}
           onMouseEnter={e => {
             e.currentTarget.style.background = 'var(--brand)';
             e.currentTarget.style.color = '#fff';
             e.currentTarget.style.borderColor = 'var(--brand)';
           }}
           onMouseLeave={e => {
             e.currentTarget.style.background = 'var(--bg-muted)';
             e.currentTarget.style.color = 'var(--fg-secondary)';
             e.currentTarget.style.borderColor = 'var(--border-faint)';
           }}>
          <SocialIcon network={s.network}/>
        </a>
      ))}
    </div>
  );
}

function LandingNav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const links = [
    { label: 'Cómo funciona', href: '#how' },
    { label: 'Cobertura', href: '#coverage' },
    { label: 'Reclamaciones', href: '#claims' },
    { label: 'Beneficios', href: '#benefits' },
    { label: 'Developers', href: '#api' },
    { label: 'FAQ', href: '#faq' },
  ];
  return (
    <header style={{
      position: 'sticky', top: 0, zIndex: 50,
      background: scrolled ? 'rgba(255,255,255,0.8)' : 'transparent',
      backdropFilter: scrolled ? 'saturate(180%) blur(12px)' : 'none',
      borderBottom: scrolled ? '1px solid var(--border)' : '1px solid transparent',
      transition: 'all 0.2s ease',
    }}>
      <div className="container r-nav-row flex items-center justify-between" style={{ height: 88 }}>
        <Wordmark height={56} />
        <nav className="r-hide-mobile flex items-center gap-8" style={{ fontSize: 14 }}>
          {links.map(l => (
            <a key={l.href} href={l.href} className="secondary" style={{
              fontWeight: 500, transition: 'color 0.15s',
            }} onMouseEnter={e => e.target.style.color = 'var(--fg)'}
               onMouseLeave={e => e.target.style.color = 'var(--fg-secondary)'}>
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href="https://app.autopacksafe.com/login" className="r-hide-mobile btn btn-ghost btn-sm">Entrar</a>
          <a href="https://app.autopacksafe.com/registro" className="btn btn-primary btn-sm">
            Crear cuenta <Icon name="arrow" size={14}/>
          </a>
        </div>
      </div>
    </header>
  );
}

// ===== HERO — Editorial variant (huge type, asymmetric) =====
function HeroEditorial() {
  return (
    <section style={{ position: 'relative', overflow: 'hidden', paddingTop: 80, paddingBottom: 120 }}>
      <div className="grid-bg" style={{
        position: 'absolute', inset: 0,
        maskImage: 'radial-gradient(ellipse at 50% 30%, black 30%, transparent 75%)',
      }}></div>

      <div className="container" style={{ position: 'relative' }}>
        <h1 className="h-display" style={{ marginBottom: 32, maxWidth: 1100 }}>
          Protege cada paquete que envías.
          <br/>
          <span style={{ color: 'var(--fg-muted)' }}>Sin papeleo, sin fricción,</span>
          <br/>
          <span style={{
            background: 'linear-gradient(135deg, var(--brand) 0%, var(--brand-3) 100%)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}>al precio de un café.</span>
        </h1>

        <div className="r-grid-hero">
          <div>
            <p className="secondary" style={{
              fontSize: 18, lineHeight: 1.5, maxWidth: 560, margin: 0,
            }}>
              Cuida los envíos de tu plataforma contra <strong style={{color: 'var(--fg)'}}>accidentes en tránsito, incendio y robo con violencia</strong>,
              con DHL, FedEx, Estafeta, Paquetexpress, UPS y más. La protección se activa
              al generar la guía y queda ligada a su número de rastreo.
            </p>
            <div className="flex items-center gap-3" style={{ marginTop: 32, flexWrap: 'wrap' }}>
              <a href="https://app.autopacksafe.com/registro" className="btn btn-primary btn-lg">
                Crear cuenta gratis <Icon name="arrow" size={16}/>
              </a>
              <a href="#how" className="btn btn-secondary btn-lg">
                Ver cómo funciona <Icon name="arrow-down" size={16}/>
              </a>
            </div>
            <div className="flex items-center gap-6" style={{ marginTop: 28, fontSize: 13, color: 'var(--fg-muted)', flexWrap: 'wrap' }}>
              <span className="flex items-center gap-2"><Icon name="check" size={14} color="var(--success)"/> Activa al generar la guía</span>
              <span className="flex items-center gap-2"><Icon name="check" size={14} color="var(--success)"/> Sin mínimos mensuales</span>
              <span className="flex items-center gap-2"><Icon name="check" size={14} color="var(--success)"/> Constancia por envío</span>
            </div>
          </div>

          {/* Right: protected shipment card */}
          <ShipmentCard/>
        </div>
      </div>
    </section>
  );
}

// ===== HERO — Centered variant (more conventional) =====
function HeroCentered() {
  return (
    <section style={{ position: 'relative', overflow: 'hidden', paddingTop: 80, paddingBottom: 120 }}>
      <div className="dot-bg" style={{
        position: 'absolute', inset: 0,
        maskImage: 'radial-gradient(ellipse at 50% 40%, black 0%, transparent 60%)',
      }}></div>
      <div className="container" style={{ position: 'relative', textAlign: 'center' }}>
        <h1 className="h-display" style={{ marginBottom: 28, maxWidth: 980, marginLeft: 'auto', marginRight: 'auto' }}>
          Protege tus envíos
          <br/>
          ante cualquier <span style={{
            background: 'linear-gradient(135deg, var(--brand) 0%, var(--brand-3) 100%)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}>accidente</span>.
        </h1>
        <p className="secondary" style={{
          fontSize: 20, lineHeight: 1.5, maxWidth: 680, margin: '0 auto 40px',
        }}>
          Cuida los envíos de tu plataforma contra accidentes en tránsito, incendio y robo
          con violencia, con la paquetería que ya usas. Activa desde que generas la guía.
        </p>
        <div className="flex items-center justify-center gap-3" style={{ marginBottom: 64, flexWrap: 'wrap' }}>
          <a href="https://app.autopacksafe.com/registro" className="btn btn-primary btn-lg">
            Crear cuenta gratis <Icon name="arrow" size={16}/>
          </a>
          <a href="#how" className="btn btn-secondary btn-lg">
            Ver cómo funciona <Icon name="arrow-down" size={16}/>
          </a>
        </div>
        <div style={{ maxWidth: 480, margin: '0 auto', textAlign: 'left' }}>
          <ShipmentCard/>
        </div>
      </div>
    </section>
  );
}

// ===== Hero visual — a protected shipment as the customer sees it =====
const fmtMXN = (n) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(n);

function ShipmentCard() {
  const coverage = ['Accidente en tránsito', 'Incendio', 'Robo con violencia'];
  const timeline = [
    { label: 'Guía generada · protección activa', time: '09:02', state: 'done' },
    { label: 'Recolectado', time: '11:14', state: 'done' },
    { label: 'En tránsito', time: '14:02', state: 'current' },
    { label: 'Entregado', time: 'Est. mañana', state: 'pending' },
  ];
  const row = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 13, padding: '10px 0' };
  return (
    <div className="card" style={{
      padding: 0, borderRadius: 'var(--r-xl)', overflow: 'hidden',
      boxShadow: '0 24px 60px -16px rgba(15, 23, 42, 0.22)',
    }}>
      {/* Header */}
      <div className="flex items-center justify-between" style={{
        padding: '18px 24px', borderBottom: '1px solid var(--border-faint)', background: 'var(--bg-soft)',
      }}>
        <div>
          <div className="text-mono" style={{ fontSize: 11, color: 'var(--fg-muted)', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
            Envío #AP4513
          </div>
          <div style={{ fontWeight: 600, fontSize: 15, marginTop: 2 }}>DHL Express · Nacional</div>
        </div>
        <span className="pill pill-success"><Icon name="shield-check" size={14}/> Protegido</span>
      </div>

      <div style={{ padding: '20px 24px' }}>
        {/* Route */}
        <div className="flex items-center gap-3" style={{ marginBottom: 16 }}>
          <div style={{ flex: 1 }}>
            <div className="text-mono" style={{ fontSize: 10, color: 'var(--fg-muted)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Origen</div>
            <div style={{ fontWeight: 600, fontSize: 15 }}>Guadalajara, JAL</div>
          </div>
          <div style={{
            width: 36, height: 36, borderRadius: '50%', flexShrink: 0,
            background: 'var(--brand-soft)', color: 'var(--brand)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <Icon name="truck" size={18}/>
          </div>
          <div style={{ flex: 1, textAlign: 'right' }}>
            <div className="text-mono" style={{ fontSize: 10, color: 'var(--fg-muted)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Destino</div>
            <div style={{ fontWeight: 600, fontSize: 15 }}>Tampico, TAMPS</div>
          </div>
        </div>

        {/* Details */}
        <div style={{ borderTop: '1px solid var(--border-faint)' }}>
          <div style={{ ...row, borderBottom: '1px solid var(--border-faint)' }}>
            <span className="secondary">Número de guía</span>
            <span className="text-mono">2845 1293 8401</span>
          </div>
          <div style={{ ...row, borderBottom: '1px solid var(--border-faint)' }}>
            <span className="secondary">Valor protegido</span>
            <span className="text-mono" style={{ fontWeight: 600 }}>{fmtMXN(12500)}</span>
          </div>
        </div>

        {/* Coverage */}
        <div className="flex items-center gap-2" style={{ marginTop: 16, flexWrap: 'wrap' }}>
          {coverage.map(c => (
            <span key={c} className="pill pill-neutral" style={{ fontSize: 12 }}>
              <Icon name="check" size={12} color="var(--success)"/> {c}
            </span>
          ))}
        </div>

        {/* Timeline */}
        <div style={{ marginTop: 20, display: 'grid', gap: 12 }}>
          {timeline.map(t => (
            <div key={t.label} className="flex items-center gap-3" style={{ fontSize: 13 }}>
              <span style={{
                width: 10, height: 10, borderRadius: '50%', flexShrink: 0,
                background: t.state === 'pending' ? 'var(--border)' : t.state === 'current' ? 'var(--brand)' : 'var(--success)',
                boxShadow: t.state === 'current' ? '0 0 0 4px var(--brand-soft)' : 'none',
              }}/>
              <span style={{ flex: 1, color: t.state === 'pending' ? 'var(--fg-muted)' : 'var(--fg)', fontWeight: t.state === 'current' ? 600 : 400 }}>
                {t.label}
              </span>
              <span className="text-mono" style={{ fontSize: 11, color: 'var(--fg-muted)' }}>{t.time}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="flex items-center justify-between" style={{
        padding: '14px 24px', borderTop: '1px solid var(--border-faint)', background: 'var(--bg-soft)', fontSize: 13,
      }}>
        <span className="flex items-center gap-2 secondary"><Icon name="file" size={14}/> Constancia de protección</span>
        <span className="flex items-center gap-1" style={{ color: 'var(--brand)', fontWeight: 500 }}>
          <Icon name="download" size={14}/> PDF
        </span>
      </div>
    </div>
  );
}

function highlightCode(s) {
  return s
    .replace(/(".*?")/g, '<span style="color:#a5b4fc">$1</span>')
    .replace(/\b(curl|const|import|from|await|new|echo|public|env)\b/g, '<span style="color:#f0abfc">$1</span>')
    .replace(/(\$[a-z_]+)/g, '<span style="color:#fcd34d">$1</span>')
    .replace(/(\b\d+\b)/g, '<span style="color:#86efac">$1</span>')
    .replace(/(\/\/.*$)/gm, '<span style="color:#6b7280">$1</span>');
}

// ===== Logo strip =====
function CarrierStrip() {
  const carriers = ['DHL', 'FedEx', 'Estafeta', 'Paquetexpress', 'J&T Express', 'UPS', 'Sendex'];
  return (
    <section style={{ padding: '48px 0', borderTop: '1px solid var(--border-faint)', borderBottom: '1px solid var(--border-faint)' }}>
      <div className="container">
        <div className="text-mono" style={{
          fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.12em',
          color: 'var(--fg-muted)', textAlign: 'center', marginBottom: 28,
        }}>
          Compatible con las principales paqueterías de México
        </div>
        <div className="flex items-center justify-between" style={{ flexWrap: 'wrap', gap: 32 }}>
          {carriers.map(c => (
            <div key={c} style={{
              fontFamily: 'var(--font-sans)', fontWeight: 700, fontSize: 22,
              color: 'var(--fg-faint)', letterSpacing: '-0.02em',
              filter: 'grayscale(1)',
              transition: 'color 0.2s',
            }} onMouseEnter={e => e.target.style.color='var(--fg-secondary)'}
               onMouseLeave={e => e.target.style.color='var(--fg-faint)'}>
              {c}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ===== How it works =====
function HowItWorks() {
  const steps = [
    { n: '01', icon: 'user', title: 'Crea tu cuenta',
      desc: 'Da de alta a tu empresa en minutos. Sin papeleo y sin cambiar de paquetería.' },
    { n: '02', icon: 'package', title: 'Protege al generar la guía',
      desc: 'Activa la protección al generar cada guía, desde el panel de AutoPackSafe o conectando tu plataforma.' },
    { n: '03', icon: 'shield-check', title: 'Recibe tu constancia',
      desc: 'Cada envío protegido genera una Constancia de Protección ligada a su número de rastreo, lista para compartir.' },
    { n: '04', icon: 'alert-triangle', title: '¿Incidencia? Repórtala',
      desc: 'Levanta tu reclamación desde el panel con la evidencia del envío. Emitimos dictamen en máximo 10 días hábiles.' },
  ];
  return (
    <section className="section" id="how">
      <div className="container">
        <div style={{ marginBottom: 64, maxWidth: 720 }}>
          <div className="eyebrow" style={{ marginBottom: 16 }}>Cómo funciona</div>
          <h2 className="h-1">Protege tus envíos en 4 pasos.</h2>
          <p className="secondary" style={{ fontSize: 18, lineHeight: 1.5, marginTop: 20, marginBottom: 0 }}>
            Sin trámites largos ni cambiar tu operación. AutoPackSafe se suma a la forma
            en la que ya envías y protege cada paquete desde que generas su guía.
          </p>
        </div>
        <div className="r-grid r-grid-4">
          {steps.map(s => (
            <div key={s.n} style={{ position: 'relative' }}>
              <div className="text-mono" style={{
                fontSize: 11, color: 'var(--brand)', letterSpacing: '0.1em', marginBottom: 24,
              }}>{s.n}</div>
              <div style={{
                width: 44, height: 44, borderRadius: 10,
                background: 'var(--brand-soft)', color: 'var(--brand)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                marginBottom: 20,
              }}>
                <Icon name={s.icon} size={22}/>
              </div>
              <h3 className="h-3" style={{ marginBottom: 10 }}>{s.title}</h3>
              <p className="secondary" style={{ fontSize: 14, lineHeight: 1.55, margin: 0 }}>
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ===== Coverage — what is and isn't covered (source: Términos y Condiciones §5, §7, §10) =====
function Coverage() {
  const covered = [
    { icon: 'truck', title: 'Accidentes en tránsito',
      desc: 'Colisión, volcadura, descarrilamiento o caída de aeronave del medio que transporta tu envío, y rotura de puentes o embarcaciones necesarias para el trayecto.' },
    { icon: 'zap', title: 'Incendio, rayo o explosión',
      desc: 'Daños materiales directos a tu mercancía causados por incendio, rayo o explosión del medio de transporte, en cualquier modalidad.' },
    { icon: 'lock', title: 'Robo total con violencia',
      desc: 'Si tu envío es robado por completo mediante asalto o violencia. Solo requiere la denuncia ante el Ministerio Público.' },
  ];
  const notCovered = [
    'Dinero en efectivo, valores, tarjetas y documentos financieros',
    'Metales y piedras preciosas',
    'Armas de fuego, municiones, explosivos y pirotecnia',
    'Animales vivos, vacunas y productos biológicos',
    'Tabaco, combustibles y sustancias radioactivas',
    'Mudanzas y menajes de casa',
    'Documentos de cualquier tipo (placas, engomados, certificados)',
    'Mercancía ilegal o prohibida en origen o destino',
    'Robo sin violencia, ratería o hurto',
    'Daños por embalaje insuficiente o inadecuado',
    'Daños preexistentes o fallas eléctricas y mecánicas sin un accidente de por medio',
    'Envíos con fleteros independientes o paquetería local no formal',
  ];
  return (
    <section className="section" id="coverage" style={{ background: 'var(--bg-soft)' }}>
      <div className="container">
        <div style={{ marginBottom: 64, maxWidth: 720 }}>
          <div className="eyebrow" style={{ marginBottom: 16 }}>Cobertura</div>
          <h2 className="h-1">¿Qué cubre la protección de AutoPackSafe?</h2>
          <p className="secondary" style={{ fontSize: 18, lineHeight: 1.5, marginTop: 20, marginBottom: 0 }}>
            Te cubrimos ante los riesgos de tránsito que más pérdidas generan. Recibe una
            compensación de hasta el valor declarado en la Constancia de Protección de tu envío.
          </p>
        </div>

        <div className="r-grid r-grid-3">
          {covered.map((c, i) => (
            <div key={c.title} className="card" style={{ padding: 32 }}>
              <div className="flex items-center justify-between" style={{ marginBottom: 28 }}>
                <span className="text-mono" style={{ fontSize: 11, color: 'var(--fg-muted)', letterSpacing: '0.1em' }}>
                  0{i + 1} / 0{covered.length}
                </span>
                <span className="pill pill-success"><Icon name="check" size={12}/> Cubierto</span>
              </div>
              <div style={{
                width: 48, height: 48, borderRadius: 12,
                background: 'var(--brand-soft)', color: 'var(--brand)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                marginBottom: 20,
              }}>
                <Icon name={c.icon} size={24}/>
              </div>
              <h3 className="h-3" style={{ marginBottom: 10 }}>{c.title}</h3>
              <p className="secondary" style={{ fontSize: 14, lineHeight: 1.55, margin: 0 }}>{c.desc}</p>
            </div>
          ))}
        </div>

        <div className="card" style={{ marginTop: 24, padding: 32 }}>
          <div className="flex items-center gap-3" style={{ marginBottom: 24, flexWrap: 'wrap' }}>
            <span className="pill pill-danger"><Icon name="x" size={12}/> No cubierto</span>
            <span className="secondary" style={{ fontSize: 14 }}>Lee con atención antes de contratar.</span>
          </div>
          <div style={{
            display: 'grid', gap: '14px 32px',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          }}>
            {notCovered.map(item => (
              <div key={item} className="flex gap-3" style={{ fontSize: 14, color: 'var(--fg-secondary)', lineHeight: 1.45 }}>
                <Icon name="x" size={14} color="var(--danger)" style={{ flexShrink: 0, marginTop: 3 }}/>
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

// ===== Claims — process, deadlines, deductibles (source: T&C §6, §13, §14) =====
function Claims() {
  const steps = [
    { n: '01', title: 'Reporta a tiempo',
      desc: 'Daño o faltante: 5 días hábiles tras la entrega. Robo con violencia: 5 días hábiles tras el evento, con denuncia ante el Ministerio Público.' },
    { n: '02', title: 'Envía tu evidencia',
      desc: 'Identificación oficial, Constancia de Protección y guía, factura timbrada ante el SAT con descripción específica, y fotos o video del paquete y del daño.' },
    { n: '03', title: 'Recibe tu dictamen',
      desc: 'Con la documentación completa emitimos dictamen en máximo 10 días hábiles. Tienes 72 horas para aportar evidencia adicional.' },
    { n: '04', title: 'Recibe tu compensación',
      desc: 'Según el caso: reparación del bien, compensación proporcional al daño o el 100% del valor declarado en pérdida total.' },
  ];
  const deductibles = [
    { label: 'Incendio, explosión o accidente del medio de transporte', value: '0%' },
    { label: 'Tránsito marítimo o aéreo (importación / exportación)', value: '0%' },
    { label: 'Robo total con violencia o asalto', value: '15%' },
    { label: 'Volcadura del medio de transporte', value: '15%' },
    { label: 'Cualquier otro riesgo cubierto', value: '2%' },
  ];
  const tips = [
    'Activa la protección al generar la guía: sin constancia no hay compensación.',
    'Verifica que el beneficiario sea quien aparece en la factura.',
    'Embala según el tipo de mercancía, con amortiguación y buen sellado.',
    'Si el paquete llega alterado, recházalo y pide constancia a la paquetería.',
  ];
  return (
    <section className="section" id="claims">
      <div className="container">
        <div style={{ marginBottom: 64, maxWidth: 720 }}>
          <div className="eyebrow" style={{ marginBottom: 16 }}>Reclamaciones</div>
          <h2 className="h-1">Si algo pasa, así te compensamos.</h2>
          <p className="secondary" style={{ fontSize: 18, lineHeight: 1.5, marginTop: 20, marginBottom: 0 }}>
            Un proceso claro, con plazos definidos y sin letras chiquitas.
          </p>
        </div>

        <div className="r-grid r-grid-4">
          {steps.map(s => (
            <div key={s.n} style={{ borderTop: '2px solid var(--brand)', paddingTop: 20 }}>
              <div className="text-mono" style={{ fontSize: 11, color: 'var(--brand)', letterSpacing: '0.1em', marginBottom: 12 }}>{s.n}</div>
              <h3 className="h-3" style={{ marginBottom: 10 }}>{s.title}</h3>
              <p className="secondary" style={{ fontSize: 14, lineHeight: 1.55, margin: 0 }}>{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="r-grid r-grid-2" style={{ marginTop: 48 }}>
          <div className="card" style={{ padding: 32 }}>
            <h3 className="h-3" style={{ marginBottom: 6 }}>Deducibles</h3>
            <p className="secondary" style={{ fontSize: 13, lineHeight: 1.5, margin: 0, marginBottom: 20 }}>
              Se descuentan del valor del envío según el tipo de incidente.
            </p>
            {deductibles.map((d, i) => (
              <div key={d.label} className="flex items-center justify-between gap-4" style={{
                padding: '12px 0', fontSize: 14,
                borderTop: i === 0 ? 'none' : '1px solid var(--border-faint)',
              }}>
                <span className="secondary">{d.label}</span>
                <span className="text-mono" style={{ fontWeight: 600, color: d.value === '0%' ? 'var(--success)' : 'var(--fg)' }}>{d.value}</span>
              </div>
            ))}
            <p className="text-mono" style={{ fontSize: 11, color: 'var(--fg-muted)', lineHeight: 1.5, margin: 0, marginTop: 16 }}>
              Envíos con valor mayor a USD $1,000: deducible mínimo de USD $200.
            </p>
          </div>

          <div className="card" style={{ padding: 32, background: 'var(--brand-soft)', borderColor: 'transparent' }}>
            <h3 className="h-3" style={{ marginBottom: 6 }}>Para que tu reclamo proceda</h3>
            <p className="secondary" style={{ fontSize: 13, lineHeight: 1.5, margin: 0, marginBottom: 20 }}>
              Cuatro cuidados que marcan la diferencia.
            </p>
            <div style={{ display: 'grid', gap: 16 }}>
              {tips.map(t => (
                <div key={t} className="flex gap-3" style={{ fontSize: 14, lineHeight: 1.5 }}>
                  <span style={{
                    width: 22, height: 22, borderRadius: '50%', flexShrink: 0,
                    background: 'var(--brand)', color: 'white',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    <Icon name="check" size={12}/>
                  </span>
                  <span>{t}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ===== Benefits =====
function Benefits() {
  const items = [
    { icon: 'shield-check', title: 'Cobertura hasta $950,000',
      desc: 'Compensación de hasta el valor declarado de cada envío, nacional o de importación y exportación.',
      stat: '$950K MXN', statLabel: 'Cobertura máx' },
    { icon: 'refresh', title: 'Dictamen en 10 días hábiles',
      desc: 'Con tu documentación completa, emitimos dictamen en un máximo de 10 días hábiles.',
      stat: '≤ 10 días', statLabel: 'Dictamen' },
    { icon: 'truck', title: 'Con la paquetería que ya usas',
      desc: 'DHL, FedEx, Estafeta, Paquetexpress, J&T Express, UPS, Sendex y más. Sin cambiar tu operación.',
      stat: '+7', statLabel: 'Paqueterías' },
    { icon: 'wallet', title: 'Sin mínimos mensuales',
      desc: 'Solo pagas por los envíos que proteges. Sin mensualidades ni penalizaciones por baja actividad.',
      stat: '0', statLabel: 'Mensualidades' },
    { icon: 'file', title: 'Constancia por envío',
      desc: 'Cada envío protegido genera una Constancia de Protección ligada a su número de rastreo.',
      stat: 'PDF', statLabel: 'Por envío' },
    { icon: 'users', title: 'Hecho para plataformas multipaquetería',
      desc: 'Protege los envíos de todos los usuarios de tu plataforma desde una sola cuenta empresarial.',
      stat: 'B2B', statLabel: 'Empresas' },
  ];
  return (
    <section className="section" id="benefits" style={{ background: 'var(--bg-soft)' }}>
      <div className="container">
        <div style={{ marginBottom: 64, maxWidth: 720 }}>
          <div className="eyebrow" style={{ marginBottom: 16 }}>Por qué AutoPackSafe</div>
          <h2 className="h-1">Pensado para empresas que envían mucho.</h2>
        </div>
        <div className="r-grid-benefits">
          {items.map((it, i) => (
            <div key={i} style={{ background: 'var(--bg)', padding: 32 }}>
              <div className="flex items-center justify-between" style={{ marginBottom: 24 }}>
                <div style={{
                  width: 40, height: 40, borderRadius: 8,
                  background: 'var(--brand-soft)', color: 'var(--brand)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <Icon name={it.icon} size={20}/>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div className="text-mono" style={{ fontSize: 18, fontWeight: 600, color: 'var(--fg)', letterSpacing: '-0.02em' }}>{it.stat}</div>
                  <div className="text-mono" style={{ fontSize: 10, color: 'var(--fg-muted)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>{it.statLabel}</div>
                </div>
              </div>
              <h3 className="h-3" style={{ marginBottom: 8 }}>{it.title}</h3>
              <p className="secondary" style={{ fontSize: 14, lineHeight: 1.55, margin: 0 }}>{it.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ===== Testimonials =====
function Testimonials() {
  const quotes = [
    { quote: 'Dejamos de absorber las pérdidas por paquetes dañados. Ahora cada envío sale protegido y lo configuramos en una tarde.',
      name: 'Marisol Vega', role: 'Dueña de Paquetería', company: '+2 MDP protegidos/mes' },
    { quote: 'La diferencia más notable es la claridad de las reclamaciones: plazos definidos y un dictamen en días, no en meses.',
      name: 'Julio Arroyo', role: 'SEO', company: 'AutoPaquete · +4 MDP protegidos/mes' },
    { quote: 'Nuestros clientes reciben su constancia de protección en el correo de confirmación. Eso solo redujo los tickets de soporte 40%.',
      name: 'Michel Solis', role: 'Founder', company: 'Planeta Envios · +400 envíos protegidos/mes' },
  ];
  return (
    <section className="section">
      <div className="container">
        <div style={{ marginBottom: 64, maxWidth: 720 }}>
          <div className="eyebrow" style={{ marginBottom: 16 }}>Casos de uso</div>
          <h2 className="h-1">Lo usan equipos que envían mucho.</h2>
        </div>
        <div className="r-grid r-grid-3">
          {quotes.map((q, i) => (
            <div key={i} className="card" style={{ padding: 32, display: 'flex', flexDirection: 'column' }}>
              <Icon name="quote" size={28} color="var(--brand)" style={{ opacity: 0.3, marginBottom: 16 }}/>
              <p style={{ fontSize: 16, lineHeight: 1.55, color: 'var(--fg)', margin: 0, marginBottom: 28, flex: 1, fontWeight: 400 }}>
                "{q.quote}"
              </p>
              <div style={{ paddingTop: 20, borderTop: '1px solid var(--border-faint)' }}>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{q.name}</div>
                <div className="text-mono" style={{ fontSize: 12, color: 'var(--fg-muted)', marginTop: 2 }}>
                  {q.role} · {q.company}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ===== API section =====
function ApiSection() {
  return (
    <section className="section" id="api" style={{ background: '#0b0b14', color: '#e4e4ed' }}>
      <div className="container">
        <div className="r-grid-api">
          <div>
            <div className="eyebrow" style={{ marginBottom: 16, color: '#a5b4fc' }}>Para developers</div>
            <h2 className="h-1" style={{ color: 'white', marginBottom: 24 }}>
              Una API que se siente como debería sentirse.
            </h2>
            <p style={{ fontSize: 18, lineHeight: 1.5, color: '#a0a0b0', margin: 0, marginBottom: 32 }}>
              REST tipada, errores predecibles, webhooks firmados, idempotency keys
              y un sandbox que se comporta exactamente como producción.
            </p>
            <div style={{ display: 'grid', gap: 16, marginBottom: 32 }}>
              {[
                { icon: 'check', text: 'SDKs oficiales: Node, PHP (Laravel), Python, Ruby' },
                { icon: 'check', text: 'Webhooks con HMAC-SHA256 y reintentos exponenciales' },
                { icon: 'check', text: 'Sandbox con datos sintéticos y simulación de siniestros' },
                { icon: 'check', text: 'OpenAPI 3.1 spec descargable' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3" style={{ fontSize: 14 }}>
                  <span style={{
                    width: 20, height: 20, borderRadius: '50%',
                    background: 'rgba(99,102,241,0.15)', color: '#a5b4fc',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    <Icon name="check" size={12}/>
                  </span>
                  <span style={{ color: '#d4d4dc' }}>{item.text}</span>
                </div>
              ))}
            </div>
            <div className="flex items-center gap-3">
              <a href="https://app.autopacksafe.com/registro" className="btn btn-lg" style={{ background: 'white', color: '#0b0b14' }}>
                Obtener API key <Icon name="arrow" size={16}/>
              </a>
              <a href="https://api.autopacksafe.com/docs/" target="_blank" rel="noopener noreferrer"
                 className="btn btn-lg" style={{ background: 'transparent', color: 'white', border: '1px solid #2a2a3e' }}>
                <Icon name="book" size={16}/> Documentación
              </a>
            </div>
          </div>

          <div style={{
            background: '#13131e', border: '1px solid #1f2030',
            borderRadius: 16, overflow: 'hidden',
            boxShadow: '0 24px 60px -16px rgba(0,0,0,0.5)',
          }}>
            <div style={{ padding: '12px 20px', borderBottom: '1px solid #1f2030', background: 'rgba(255,255,255,0.02)' }}>
              <div className="text-mono" style={{ fontSize: 11, color: '#7e7e95', letterSpacing: '0.04em' }}>
                EVENTO · policy.completed
              </div>
            </div>
            <pre style={{ margin: 0, padding: 24, fontSize: 13, lineHeight: 1.7, fontFamily: 'var(--font-mono)', color: '#e4e4ed', overflow: 'auto', maxHeight: 460 }}>
              <code dangerouslySetInnerHTML={{__html: highlightCode(`Content-Type: application/json
X-AutoPackSafe-Event: policy.completed
X-AutoPackSafe-Signature: sha256=8a7f3e2d9c1b...
X-AutoPackSafe-Delivery-Id: 142

{
  "event":     "policy.completed",
  "timestamp": "2026-05-01T21:12:03+00:00",
  "data": {
    "policy_id":       "AP4513",
    "status":          "completed",
    "insurer_name":    "AutoPackSafe",
    "insured_sum":     12500,
    "sell_price":      208.21,
    "origin":          "Guadalajara, JA",
    "destination":     "Tampico, TM",
    "coverage_start":  "2026-05-01",
    "coverage_end":    "2026-05-10",
    "tracking_number": "284512938401",
    "completed_at":    "2026-05-01T21:12:03+00:00",
    "error_message":   null
  }
}`)}}/>
            </pre>
          </div>
        </div>
      </div>
    </section>
  );
}

// ===== FAQ =====
function FAQ() {
  const items = [
    { q: '¿Qué cubre exactamente la protección?',
      a: 'Daños materiales directos a tu mercancía por accidentes del medio de transporte (colisión, volcadura, descarrilamiento, caída de aeronave), por incendio, rayo o explosión, y el robo total con violencia. El robo sin violencia no está cubierto.' },
    { q: '¿Quién puede contratar AutoPackSafe?',
      a: 'Es un servicio para empresas: personas morales que operan plataformas multipaquetería o de envíos, y que trabajan con paqueterías formales como DHL, FedEx, Estafeta, Paquetexpress, J&T Express, UPS o Sendex.' },
    { q: '¿Qué tipo de servicio es AutoPackSafe?',
      a: 'Es un servicio privado de protección y compensación para envíos, administrado directamente por AutoPackSafe, con reglas claras sobre qué se cubre y cómo se compensa.' },
    { q: '¿Necesito saber programar para usar AutoPackSafe?',
      a: 'No. Puedes proteger tus envíos directamente desde el panel de AutoPackSafe. La API es opcional, para empresas que quieren automatizar la protección desde su propio sistema.' },
    { q: '¿Cuándo debo activar la protección?',
      a: 'Al momento de generar la guía. La protección queda ligada al número de rastreo y entra en vigor desde la fecha y hora de su Constancia de Protección. Los envíos sin constancia no tienen derecho a compensación.' },
    { q: '¿Cuánto me compensan?',
      a: 'Hasta el valor declarado en la Constancia de Protección, menos el deducible según el tipo de incidente. Se toma el subtotal sin IVA de lo menor entre el valor declarado y el valor de la factura; no incluye el costo de la guía ni gastos accesorios.' },
    { q: '¿Cómo funcionan las reclamaciones?',
      a: 'Repórtala dentro de los 5 días hábiles siguientes a la entrega (daño o faltante) o al evento (robo con violencia, con denuncia ante el Ministerio Público). Con la documentación completa emitimos dictamen en máximo 10 días hábiles.' },
    { q: '¿Puedo proteger envíos internacionales?',
      a: 'Sí. Los embarques de importación y exportación se protegen con base en el valor de factura más fletes, impuestos y gastos aduanales comprobables. En tránsito marítimo o aéreo el deducible es 0%.' },
    { q: '¿Puedo cancelar una protección?',
      a: 'Una vez emitida, la Constancia de Protección no es reembolsable, porque la cobertura queda activa desde ese momento ligada al número de rastreo.' },
  ];
  const [open, setOpen] = useState(0);
  return (
    <section className="section" id="faq">
      <div className="container" style={{ maxWidth: 920 }}>
        <div style={{ marginBottom: 56, maxWidth: 720 }}>
          <div className="eyebrow" style={{ marginBottom: 16 }}>Preguntas frecuentes</div>
          <h2 className="h-1">Lo que deberías saber.</h2>
        </div>
        <div style={{ borderTop: '1px solid var(--border)' }}>
          {items.map((it, i) => (
            <div key={i} style={{ borderBottom: '1px solid var(--border)' }}>
              <button onClick={() => setOpen(open === i ? -1 : i)} style={{
                width: '100%', padding: '24px 0', display: 'flex',
                alignItems: 'center', justifyContent: 'space-between',
                background: 'transparent', border: 'none', textAlign: 'left',
                cursor: 'pointer', color: 'var(--fg)',
              }}>
                <span style={{ fontSize: 17, fontWeight: 500, letterSpacing: '-0.01em' }}>{it.q}</span>
                <Icon name={open === i ? 'x' : 'plus'} size={18} color="var(--fg-muted)"/>
              </button>
              {open === i && (
                <div style={{
                  paddingBottom: 24, fontSize: 15, lineHeight: 1.6,
                  color: 'var(--fg-secondary)', maxWidth: 720,
                }}>
                  {it.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ===== CTA Bar =====
function CTABar() {
  return (
    <section style={{ padding: '80px 0' }}>
      <div className="container">
        <div className="r-cta-inner" style={{
          background: 'linear-gradient(135deg, #1e40af 0%, #4f46e5 100%)',
          borderRadius: 'var(--r-2xl)',
          padding: '64px 64px',
          color: 'white',
          position: 'relative',
          overflow: 'hidden',
        }}>
          <div style={{
            position: 'absolute', top: -100, right: -100,
            width: 400, height: 400, borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(255,255,255,0.10) 0%, transparent 70%)',
          }}/>
          <div style={{ position: 'relative', maxWidth: 720 }}>
            <h2 className="h-1" style={{ color: 'white', marginBottom: 16 }}>
              Tu próximo envío puede salir protegido.
            </h2>
            <p style={{ fontSize: 18, lineHeight: 1.5, color: 'rgba(255,255,255,0.85)', marginBottom: 32 }}>
              Crea tu cuenta gratis y protege tu primer envío en menos de 10 minutos, con la paquetería que ya usas.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://app.autopacksafe.com/registro" className="btn btn-lg" style={{ background: 'white', color: 'var(--brand)' }}>
                Crear cuenta gratis <Icon name="arrow" size={16}/>
              </a>
              <a href="#contact" className="btn btn-lg" style={{ background: 'rgba(255,255,255,0.10)', color: 'white', border: '1px solid rgba(255,255,255,0.20)', backdropFilter: 'blur(8px)' }}>
                Hablar con ventas
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ===== Footer =====
function Footer() {
  const cols = [
    { title: 'Producto', links: [
      { label: 'Cómo funciona', href: '#how' },
      { label: 'Cobertura', href: '#coverage' },
      { label: 'Reclamaciones', href: '#claims' },
      { label: 'Beneficios', href: '#benefits' },
      { label: 'Preguntas frecuentes', href: '#faq' },
    ] },
    { title: 'Cuenta', links: [
      { label: 'Crear cuenta', href: 'https://app.autopacksafe.com/registro' },
      { label: 'Iniciar sesión', href: 'https://app.autopacksafe.com/login' },
      { label: 'Reportar incidencia', href: 'https://app.autopacksafe.com/login' },
    ] },
    { title: 'Developers', links: [
      { label: 'Documentación', href: 'https://api.autopacksafe.com/docs/', external: true },
      { label: 'Integración API', href: '#api' },
    ] },
    { title: 'Empresa', links: [
      { label: 'Contacto', href: '#contact' },
      { label: 'Términos', href: '#' },
      { label: 'Privacidad', href: '#' },
    ] },
  ];
  return (
    <footer style={{ borderTop: '1px solid var(--border)', padding: '64px 0 40px' }}>
      <div className="container">
        <div className="r-grid-footer">
          <div className="r-footer-wordmark">
            <Wordmark height={56} />
            <p className="secondary" style={{ fontSize: 13, lineHeight: 1.6, marginTop: 24, maxWidth: 280 }}>
              Protección de envíos para empresas de logística en México. Sencilla, transparente y accesible.
            </p>
            <SocialLinks/>
          </div>
          {cols.map(c => (
            <div key={c.title}>
              <div className="text-mono" style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'var(--fg-muted)', marginBottom: 16 }}>
                {c.title}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {c.links.map(l => (
                  <a key={l.label} href={l.href}
                     {...(l.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                     style={{ fontSize: 14, color: 'var(--fg-secondary)' }}>{l.label}</a>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="r-footer-bottom" style={{
          marginTop: 64, paddingTop: 24,
          borderTop: '1px solid var(--border-faint)',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          fontSize: 13, color: 'var(--fg-muted)',
        }}>
          <span>
            © 2026 AutoPackSafe S.A. de C.V.
          </span>
          <span className="text-mono" style={{ fontSize: 12 }}>
            Desarrollado con <span style={{ color: '#e11d48' }}>♥</span> por{' '}
            <a href="https://mantarraya.com.mx" target="_blank" rel="noopener noreferrer"
               style={{ color: 'var(--brand)', fontWeight: 500 }}>
              Mantarraya
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}

// ===== Contact (with live form validation) =====
function Contact() {
  const [values, setValues] = useState({ name: '', email: '', company: '', message: '' });
  const [touched, setTouched] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const validate = (v) => {
    const errs = {};
    if (!v.name.trim()) errs.name = 'El nombre es obligatorio';
    else if (v.name.trim().length < 2) errs.name = 'Demasiado corto';

    if (!v.email.trim()) errs.email = 'El email es obligatorio';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.email)) errs.email = 'Email inválido';

    if (!v.company.trim()) errs.company = 'La empresa es obligatoria';
    else if (v.company.trim().length < 2) errs.company = 'Demasiado corto';

    if (!v.message.trim()) errs.message = 'El mensaje es obligatorio';
    else if (v.message.trim().length < 10) errs.message = 'Mínimo 10 caracteres';

    return errs;
  };

  const errors = validate(values);
  const isValid = Object.keys(errors).length === 0;

  const update = (field) => (e) =>
    setValues(v => ({ ...v, [field]: e.target.value }));
  const onBlur = (field) => () =>
    setTouched(t => ({ ...t, [field]: true }));

  const [submitError, setSubmitError] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setTouched({ name: true, email: true, company: true, message: true });
    if (!isValid) return;
    setSubmitting(true);
    setSubmitError(null);
    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.error || 'send_failed');
      }
      setSubmitting(false);
      setSubmitted(true);
    } catch (err) {
      setSubmitting(false);
      setSubmitError('No pudimos enviar tu mensaje. Intenta de nuevo o escríbenos directamente a contacto@autopacksafe.com.');
    }
  };

  const errorBorder = (field) =>
    touched[field] && errors[field]
      ? { borderColor: 'var(--danger)', boxShadow: '0 0 0 3px rgba(185, 28, 28, 0.10)' }
      : {};
  const errorMsgStyle = {
    fontSize: 12, color: 'var(--danger)',
    marginTop: 6, fontFamily: 'var(--font-mono)',
  };

  if (submitted) {
    return (
      <section className="section" id="contact">
        <div className="container" style={{ maxWidth: 640 }}>
          <div className="card" style={{ padding: 56, textAlign: 'center' }}>
            <div style={{
              width: 72, height: 72, borderRadius: '50%',
              background: 'var(--success-soft)', color: 'var(--success)',
              margin: '0 auto 24px', display: 'flex',
              alignItems: 'center', justifyContent: 'center',
            }}>
              <Icon name="check" size={36}/>
            </div>
            <h3 className="h-2" style={{ marginBottom: 12 }}>¡Mensaje enviado!</h3>
            <p className="secondary" style={{ fontSize: 16, lineHeight: 1.55, margin: 0 }}>
              Un asesor te contactará en menos de 24 horas. Mientras tanto,
              te invitamos a explorar la documentación.
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="section" id="contact" style={{ background: 'var(--bg-soft)' }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))',
          gap: 64, alignItems: 'start',
        }}>
          {/* Left: copy + bullets */}
          <div>
            <div className="eyebrow" style={{ marginBottom: 16 }}>Contacto</div>
            <h2 className="h-1" style={{ marginBottom: 20 }}>
              Comienza con AutoPackSafe hoy
            </h2>
            <p className="secondary" style={{ fontSize: 18, lineHeight: 1.55, marginBottom: 32 }}>
              ¿Listo para proteger los envíos de tu plataforma y dejar de absorber
              las pérdidas? Completa el formulario y un asesor te contactará en menos
              de 24 horas.
            </p>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'grid', gap: 14 }}>
              {[
                'Protege envíos desde el panel o vía API',
                'Cobertura ante accidentes en tránsito y robo con violencia',
                'Soporte técnico 24/7',
              ].map((item, i) => (
                <li key={i} className="flex items-center gap-3" style={{ fontSize: 15 }}>
                  <span style={{
                    width: 24, height: 24, borderRadius: '50%',
                    background: 'var(--brand-soft)', color: 'var(--brand)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    flexShrink: 0,
                  }}>
                    <Icon name="check" size={14}/>
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right: form */}
          <form onSubmit={onSubmit} className="card" style={{ padding: 32 }} noValidate>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div>
                <label className="label" htmlFor="contact-name">Nombre completo</label>
                <input
                  id="contact-name" type="text" className="input"
                  placeholder="Tu nombre" autoComplete="name"
                  value={values.name}
                  onChange={update('name')}
                  onBlur={onBlur('name')}
                  aria-invalid={!!(touched.name && errors.name)}
                  style={errorBorder('name')}
                />
                {touched.name && errors.name && <div style={errorMsgStyle}>{errors.name}</div>}
              </div>

              <div>
                <label className="label" htmlFor="contact-email">Email</label>
                <input
                  id="contact-email" type="email" className="input"
                  placeholder="tu@email.com" autoComplete="email"
                  value={values.email}
                  onChange={update('email')}
                  onBlur={onBlur('email')}
                  aria-invalid={!!(touched.email && errors.email)}
                  style={errorBorder('email')}
                />
                {touched.email && errors.email && <div style={errorMsgStyle}>{errors.email}</div>}
              </div>

              <div>
                <label className="label" htmlFor="contact-company">Empresa</label>
                <input
                  id="contact-company" type="text" className="input"
                  placeholder="Nombre de tu empresa" autoComplete="organization"
                  value={values.company}
                  onChange={update('company')}
                  onBlur={onBlur('company')}
                  aria-invalid={!!(touched.company && errors.company)}
                  style={errorBorder('company')}
                />
                {touched.company && errors.company && <div style={errorMsgStyle}>{errors.company}</div>}
              </div>

              <div>
                <label className="label" htmlFor="contact-message">Mensaje</label>
                <textarea
                  id="contact-message" className="input"
                  placeholder="Cuéntanos sobre tus necesidades de envío..."
                  rows={4}
                  value={values.message}
                  onChange={update('message')}
                  onBlur={onBlur('message')}
                  aria-invalid={!!(touched.message && errors.message)}
                  style={{ resize: 'vertical', minHeight: 110, ...errorBorder('message') }}
                />
                {touched.message && errors.message && <div style={errorMsgStyle}>{errors.message}</div>}
              </div>

              {submitError && (
                <div role="alert" style={{
                  padding: '12px 14px', borderRadius: 8,
                  background: 'var(--danger-soft)', color: 'var(--danger)',
                  border: '1px solid rgba(185, 28, 28, 0.18)',
                  fontSize: 13, lineHeight: 1.45,
                }}>
                  {submitError}
                </div>
              )}

              <button
                type="submit"
                className="btn btn-primary btn-lg"
                disabled={submitting || !isValid}
                style={{
                  marginTop: 8,
                  opacity: (submitting || !isValid) ? 0.55 : 1,
                  cursor: (submitting || !isValid) ? 'not-allowed' : 'pointer',
                }}
              >
                {submitting ? 'Enviando…' : 'Solicitar información'}
                {!submitting && <Icon name="arrow" size={16}/>}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

// ===== Main Landing =====
export default function LandingPage({ heroVariant }) {
  return (
    <div>
      <LandingNav/>
      {heroVariant === 'editorial' ? <HeroEditorial/> : <HeroCentered/>}
      <CarrierStrip/>
      <HowItWorks/>
      <Coverage/>
      <Claims/>
      <Benefits/>
      <Testimonials/>
      <ApiSection/>
      <FAQ/>
      <Contact/>
      <CTABar/>
      <Footer/>
      <WhatsAppFloat/>
    </div>
  );
}
